import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'

export function PageLoader(): ReactElement {
  const { t } = useTranslation()

  return (
    <div
      className="flex min-h-64 w-full items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="text-muted-foreground size-6 animate-spin" />
      <span className="sr-only">{t('state.loading')}</span>
    </div>
  )
}
